import { GET_BILLING_INFO, BillingInfoActionTypes } from './types';
import { BillingInfo } from '../../../models/BillingInfo';
import { AppState } from '../index';

export type BillingInfoState = {
    info?: BillingInfo;
};

export const INITIAL_STATE: BillingInfoState = {
    info: undefined,
};

export default function(state = INITIAL_STATE, action: BillingInfoActionTypes) {
    switch (action.type) {
        case GET_BILLING_INFO:
            const { info } = action.payload;
            return { ...state, info };
        default:
            return state;
    }
}

export const selectBillingInfo = (state: AppState): BillingInfo | undefined => state.billingInfo.info;
